import React from 'react'
import ProductImportModal from '../../../components/inventorymng/products/ProductImportModal'



const ProductImportModalContainer = ({ open, handleClose }) => {





  return (
    <ProductImportModal
      open={open}
      handleClose={handleClose}
    />
  )
}

export default ProductImportModalContainer